export default __webpack_public_path__ + "static/media/ask_interview.ed4544f3.svg";